import { render, staticRenderFns } from "./CloudflareCaptcha.vue?vue&type=template&id=280a5eba"
import script from "./CloudflareCaptcha.vue?vue&type=script&lang=js"
export * from "./CloudflareCaptcha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports